export enum EnumsStorage {
   USER_LANG = "user_lang",
}
